import { JSX, cloneElement } from 'react';

interface IProps {
    component: IIconComponent;
    className?: string;
    id?: string;
    clone?: boolean;
}

// Where to use:
// Using clone option to possibly fix the problem with repeated SVG components in safari - Should be tested
// OR
// To use conditional icons with the same configuration

export const IconWrapper = (props: IProps): JSX.Element => {
    const Icon = props.component;
    return props.clone ? (
        cloneElement(<Icon />, {
            id: props.id,
            className: props.className,
        })
    ) : (
        <Icon id={props.id} className={props.className} />
    );
};
